import io from "socket.io-client";
import { ISession } from "../declarations/auth";

const EXTENSION_ID = process.env.REACT_APP_EXTENSION_ID ?? "";
type RequestBody = {
  action: "LOGIN" | "LOGOUT";
  payload?: { refreshToken?: string; accessToken?: string; flowId?: string };
};

export const sendMessageToExtension = (request: RequestBody) => {
  try {
    try {
      const socket = io("http://localhost:5000");
      socket.emit("authenticate", { auth: request.payload?.accessToken });
      socket.on("connect_error", () => {
        socket.close();
      });
    } catch (error) {
      console.log(error);
    }

    chrome.runtime.sendMessage(EXTENSION_ID, request, (response) => {
      if (response && response.success) {
        console.log("Success ::: ", response);
      } else {
        console.log("Error sending message", response);
      }
    });
  } catch (error) {
    throw new Error(
      "Check whether the Emulator-web extension is added to your chrome browser"
    );
  }
};

export const setSession = (session: ISession | null) => {
  if (session) {
    localStorage.setItem("session", JSON.stringify(session));
  } else {
    localStorage.removeItem("session");
  }
};

export const getSession = (): ISession | null => {
  // const sessionString = localStorage.getItem("session");
  const sessionString = `{"refreshToken":"Dummy token","accessToken":"Dummy token","user":{"id":"9","name":"Guest User","picture":"","email":"guest@gmail.com","createdAt":"2022-09-07T06:34:27.883Z","updatedAt":"2023-08-16T11:13:03.003Z"}}`;
  if (sessionString) {
    return JSON.parse(sessionString);
  }
  return null;
};
